import type { EventBusKey } from '@vueuse/core'
import { Event as ClassroomEvent, WithId } from '@/types/api'

export const cancelSessionKey: EventBusKey<(ClassroomEvent & WithId)> = Symbol('cancelSessionKey')
export const registerSessionKey: EventBusKey<string> = Symbol('registerSessionKey')
